import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/newsAdmin.css";
import calenderDark from "../../assets/images/calender-dark.png";
import calender from "../../assets/images/calender.png";
import clapDark from "../../assets/images/clap-dark.png";
import clap from "../../assets/images/clap.png";
import cuttingRopeDark from "../../assets/images/cuttingRope-dark.png";
import cuttingRope from "../../assets/images/cuttingRope.png";
import deadDark from "../../assets/images/dead-dark.png";
import dead from "../../assets/images/dead.png";
import letterDark from "../../assets/images/letter-dark.png";
import letter from "../../assets/images/letter.png";
import veladatDark from "../../assets/images/veladat-dark.png";
import veladat from "../../assets/images/veladat.png";
import loadingGif from "../../assets/images/loading.gif";
import { AddNews } from "./add-news";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class Events_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsList: [],
      addNewsModal: false,
      activeNews: {},
      seeArchive: false,
      isLoading: true,
      currentEvent: 0,
      BtnList: [
        {
          img: clap,
          text: "تبریک",
        },
        {
          img: letterDark,
          text: "تسلیت",
        },
        {
          img: cuttingRopeDark,
          text: "رویداد های ویژه",
        },
        {
          img: calenderDark,
          text: "ایام تقویمی",
        },
        {
          img: deadDark,
          text: "شهادت",
        },
        {
          img: veladatDark,
          text: "ولادت",
        },
      ],
    };
    this.globalStorage = this.props.globalStorage;
  }

  componentDidMount = () => {
    this.getAnnouncements();
  };

  componentDidUpdate = (props, state) => {
    const { currentEvent } = this.state;
    if (state.currentEvent !== currentEvent) {
      this.setState({
        BtnList: [
          {
            img: currentEvent === 0 ? clap : clapDark,
            text: "تبریک",
          },
          {
            img: currentEvent === 1 ? letter : letterDark,
            text: "تسلیت",
          },
          {
            img: currentEvent === 2 ? cuttingRope : cuttingRopeDark,
            text: "رویداد های ویژه",
          },
          {
            img: currentEvent === 3 ? calender : calenderDark,
            text: "ایام تقویمی",
          },
          {
            img: currentEvent === 4 ? dead : deadDark,
            text: "شهادت",
          },
          {
            img: currentEvent === 5 ? veladat : veladatDark,
            text: "ولادت",
          },
        ],
      });
      this.getAnnouncements();
    }
  };

  getAnnouncements = () => {
    const { currentEvent, seeArchive } = this.state;
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/announcements`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        if (seeArchive) {
          this.setState({
            newsList: res.data.result.filter(
              ({ status, type }) =>
                status === "archived" && type === `${currentEvent + 2}`
            ),
          });
        } else {
          this.setState({
            newsList: res.data.result.filter(
              ({ status, type }) =>
                status === "active" && type === `${currentEvent + 2}`
            ),
          });
        }
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putData = (data) => {
    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/announcements`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.getAnnouncements();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleRow = (newsIndex, val) => {
    const { newsList } = this.state;
    const arr = [...newsList];
    arr[newsIndex] = val;
    this.setState({ newsList: arr.filter((item) => item !== null) });
  };

  handleStatus = (i) => {
    const { handleRow, putData } = this;
    const { newsList } = this.state;
    const prevStatus = newsList[i].status;
    const oppositeStatus = prevStatus === "active" ? "deactive" : "active";

    this.setState({ isLoading: true });
    handleRow(i, {
      ...newsList[i],
      status: oppositeStatus,
    });
    putData({
      id: newsList[i].id,
      status: oppositeStatus,
    });
  };

  handleArchive = (i, titleForEvent) => {
    const { handleRow, putData } = this;
    const { newsList, seeArchive } = this.state;
    const title = seeArchive ? "لغو آرشیو" : "آرشیو";
    const subTitle = seeArchive
      ? `آیا از لغو آرشیو ${titleForEvent} مطمئن هستید؟`
      : `آیا از آرشیو ${titleForEvent} مطمئن هستید؟`;

    this.props.dispatch(userActions.question(title, subTitle)).then((r) => {
      if (r.value) {
        handleRow(i, null);
        putData({
          id: newsList[i].id,
          status: seeArchive ? "active" : "archived",
        });
      }
    });
  };

  getUnitString = (value, unit) => {
    return `${value} ${unit}`;
    // return `${value} ${unit}${value > 1 ? "s" : ""}`;
  };

  formatDuration = (seconds) => {
    // if (seconds === 0) return "اتمام زمان انجام کار";
    if (seconds < 61) return "کمتر از یک دقیقه";

    if (seconds < 86400) {
      //less than a day
      const units = [
        // { unit: "سال", duration: 60 * 60 * 24 * 365 },
        // { unit: "روز", duration: 60 * 60 * 24 },
        { unit: "ساعت", duration: 60 * 60 },
        { unit: "دقیقه", duration: 60 },
        // { unit: "ثانیه", duration: 1 },
      ];

      const result = units
        .map(({ unit, duration }) => {
          const value = Math.floor(seconds / duration);
          seconds -= value * duration;
          return value > 0 ? this.getUnitString(value, unit) : null;
        })
        .filter((unitString) => unitString !== null);

      return result.length === 1 ? result[0] : result.join(" و ");
    } else {
      //more than a day
      const units = [
        { unit: "سال", duration: 60 * 60 * 24 * 365 },
        { unit: "روز", duration: 60 * 60 * 24 },
        // { unit: "ساعت", duration: 60 * 60 },
        // { unit: "دقیقه", duration: 60 },
        // { unit: "ثانیه", duration: 1 },
      ];

      const result = units
        .map(({ unit, duration }) => {
          const value = Math.floor(seconds / duration);
          seconds -= value * duration;
          return value > 0 ? this.getUnitString(value, unit) : null;
        })
        .filter((unitString) => unitString !== null);

      return result.length === 1 ? result[0] : result.join(" و ");
    }
  };

  render() {
    const { handleArchive, handleStatus, dispatch, formatDuration } = this;
    const { newsList, seeArchive, addNewsModal, BtnList, currentEvent } =
      this.state;

    let title;
    switch (currentEvent) {
      case 0: {
        title = "تبریک";
        break;
      }
      case 1: {
        title = "تسلیت";
        break;
      }
      case 2: {
        title = "رویداد های ویژه";
        break;
      }
      case 3: {
        title = "ایام تقویمی";
        break;
      }
      case 4: {
        title = "شهادت";
        break;
      }
      case 5: {
        title = "ولادت";
        break;
      }
      default:
        return "xxx";
    }

    return (
      <div className="container-fluid px-5 pb-5 mt-3 newsAdmin">
        <div className="row my-1">
          <Navigation
            onClick={(i) => this.setState({ currentEvent: i })}
            BtnList={BtnList}
          />
        </div>
        <div className="row">
          <div className="col-lg-9 col-md-12 m-auto">
            <List
              currentEvent={currentEvent}
              seeArchive={seeArchive}
              onAdd={() => {
                this.setState({ addNewsModal: true });
              }}
              onArchive={() => {
                this.setState(
                  { seeArchive: !this.state.seeArchive },
                  this.getAnnouncements
                );
              }}
            >
              {seeArchive ? (
                newsList.length ? (
                  newsList.map((news, i) => (
                    <ListItem2
                      i={i}
                      key={i + 1}
                      news={news}
                      formatDuration={formatDuration}
                      onArchive={() => handleArchive(i, title)}
                    />
                  ))
                ) : (
                  <EmptyListItem />
                )
              ) : newsList.length ? (
                newsList.map((news, i) => (
                  <ListItem
                    i={i}
                    key={i + 1}
                    news={news}
                    dispatch={dispatch}
                    onStatus={() => handleStatus(i)}
                    onArchive={() => handleArchive(i, title)}
                    onEdit={(id) => {
                      this.setState({
                        addNewsModal: !this.state.addNewsModal,
                        activeNews: this.state.newsList.find(
                          (news) => news.id === id
                        ),
                      });
                    }}
                  />
                ))
              ) : (
                <EmptyListItem />
              )}
            </List>
            <Modal
              isOpen={addNewsModal}
              // isOpen={true}
              contentLabel="Monitor Modal"
              portalClassName="full_screen_modal"
            >
              <AddNews
                title={title}
                data={this.state.activeNews}
                currentEvent={currentEvent}
                handleModal={() => {
                  this.setState({ addNewsModal: !this.state.addNewsModal });
                }}
                afterPost={this.getAnnouncements}
              />
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

class Navigation extends Component {
  render() {
    const { onClick, BtnList } = this.props;
    return (
      <div className="col-lg-12 indexSec">
        <div className="border-0 h-100 ">
          <RoundedBtnWrapper>
            {BtnList.map(({ img, text }, i) => (
              <RoundedBtn
                key={i}
                img={img}
                text={text}
                onClick={() => onClick(i)}
              />
            ))}
          </RoundedBtnWrapper>
        </div>
      </div>
    );
  }
}

class RoundedBtnWrapper extends Component {
  render() {
    return (
      <div
        className="card border-0"
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div className="card-body" style={{ height: "200px" }}>
          <div className="d-flex flex-wrap justify-content-center">
            <div className="card-deck">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

class RoundedBtn extends Component {
  render() {
    const { img, text, onClick } = this.props;
    return (
      <div
        className="card text-center border-0 "
        style={{ borderRadius: "20px", background: "transparent" }}
      >
        <div
          className="card-body border-0 d-flex"
          style={{ padding: "1.25rem 0" }}
        >
          <a
            className="d-flex flex-column align-items-center indexs btn"
            onClick={onClick}
          >
            <img src={img} alt="" width="75" height="75" />
            <span
              className="iran-sans_Bold text-center text-dark my-2"
              style={{
                width: "100px",
                fontSize: "12px",
                paddingTop: "10px",
              }}
            >
              {text}
            </span>
          </a>
        </div>
      </div>
    );
  }
}

class EmptyListItem extends Component {
  render() {
    return (
      <li className="newsAdmin__list__item empty-list">
        <p className="newsAdmin__list__item__text empty-list__child">
          برای نمایش اطلاعات از دکمه های بالا استفاده نمایید
        </p>
      </li>
    );
  }
}

class List extends Component {
  render() {
    const { onAdd, onArchive, seeArchive, currentEvent } = this.props;

    let title;
    switch (currentEvent) {
      case 0: {
        title = "تبریک";
        break;
      }
      case 1: {
        title = "تسلیت";
        break;
      }
      case 2: {
        title = "رویداد های ویژه";
        break;
      }
      case 3: {
        title = "ایام تقویمی";
        break;
      }
      case 4: {
        title = "شهادت";
        break;
      }
      case 5: {
        title = "ولادت";
        break;
      }
      default:
        return "xxx";
    }

    return (
      <div className='list-wrapper'>
        <ul className='newsAdmin__list'>
          <Banner seeArchive={seeArchive} currentEvent={currentEvent} />
          {this.props.children}
        </ul>
        <div className='d-flex justify-content-center mt-3 align-items-center '>
          {seeArchive ? (
            <button
              className='btn btn-primary rounded-pill text-center mx-1'
              onClick={onArchive}
              style={{ minWidth: '150px' }}
            >
              <p className='py-1 m-0'> {`مشاهده ${title} ها`}</p>
            </button>
          ) : (
            <>
              <button
                className='btn btn-primary rounded-pill text-center mx-1 add_event_btn'
                onClick={onAdd}
              >
                <p className='m-0 py-2'>{`افرودن ${title}`}</p>
              </button>
              <button
                className='btn  rounded-pill text-center mx-1 add_event_btn empty_button '
                onClick={onArchive}
                style={{
                  border: '1px solid #104c82',
                  color: '#104c82',
                }}
              >
                <p className='m-0 py-2'>{`آرشیو ${title} ها`}</p>
              </button>
            </>
          )}
        </div>
      </div>
    );
  }
}

class Banner extends Component {
  render() {
    const { seeArchive, currentEvent } = this.props;
    const grid = seeArchive
      ? "1fr 10fr 2fr 2fr 2fr 2fr"
      : "1fr 10fr 2fr 2fr 2fr";

    let bannerTitle;
    switch (currentEvent) {
      case 0: {
        bannerTitle = "تبریک";
        break;
      }
      case 1: {
        bannerTitle = "تسلیت";
        break;
      }
      case 2: {
        bannerTitle = "رویداد های ویژه";
        break;
      }
      case 3: {
        bannerTitle = "ایام تقویمی";
        break;
      }
      case 4: {
        bannerTitle = "شهادت";
        break;
      }
      case 5: {
        bannerTitle = "ولادت";
        break;
      }
      default:
        return "xxx";
    }

    return (
      <li
        className="newsAdmin__list__banner"
        key="0"
        style={{ gridTemplateColumns: grid }}
      >
        <div className="newsAdmin__list__banner__child">ردیف</div>
        <div className="newsAdmin__list__banner__child">{`عنوان ${bannerTitle}`}</div>
        {seeArchive && (
          <div className="newsAdmin__list__banner__child">مدت زمان انتشار</div>
        )}
        <div className="newsAdmin__list__banner__child">
          {seeArchive ? "تاریخ آرشیو" : "وضعیت انتشار"}
        </div>
        <div className="newsAdmin__list__banner__child">تاریخ انتشار</div>
        <div className="newsAdmin__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem2 extends Component {
  render() {
    if (this.props.news === undefined) return null;

    const { i, news, onArchive, formatDuration } = this.props;
    const {
      id,
      title,
      // subtitle,
      // body,
      // category,
      // author,
      // seen_count,
      status,
      created_at,
      updated_at,
    } = news;
    const grid = "1fr 10fr 2fr 2fr 2fr 2fr";

    const startInSecondes = Math.floor(new Date(created_at).getTime() / 1000);
    const finishInSecondes = Math.floor(new Date(updated_at).getTime() / 1000);
    const passed = finishInSecondes - startInSecondes;

    return (
      <li
        className={`newsAdmin__list__item`}
        style={{ gridTemplateColumns: grid }}
      >
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDuration(passed)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(updated_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(created_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className={`library-dark-icon`} onClick={onArchive} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    if (this.props.news === undefined) return null;

    const { i, news, onStatus, onArchive, onEdit } = this.props;
    const {
      id,
      title,
      // subtitle,
      // body,
      // category,
      // author,
      // seen_count,
      status,
      created_at,
    } = news;

    return (
      <li className={`newsAdmin__list__item`}>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{i + 1}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">{title}</p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound
            className={`${
              status === "active"
                ? "success"
                : status === "deactive"
                ? "error"
                : "library"
            }-icon`}
            onClick={onStatus}
          />
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <p className="newsAdmin__list__item__text">
            {formatDate(created_at)}
          </p>
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          <BtnRound className="edit-icon" onClick={() => onEdit(id)} />
          <BtnRound className={`library-icon`} onClick={onArchive} />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <button
        className={`btn-round ${this.props.className}`}
        onClick={this.props.onClick}
        data-tip={this.props.data_tip}
      ></button>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="newsAdmin__list__item__btn-container">
        {this.props.children}
        {/* <ReactTooltip type="dark" /> */}
      </div>
    );
  }
}


class Loading extends Component {
  render() {
    return (
      <li className="newsAdmin__list__item empty-list">
        <img src={loadingGif} style={{ width: "160px" }} />
      </li>
    );
  }
}

const Events = connect((state) => ({
  globalStorage: state.globalStorage,
}))(Events_);

export { Events };
